/** Search-parameter serialisation for the TanStack router. */

/** Values carried in the URL are always strings, exactly as `router.query`. */
type SearchRecord = Record<string, string>;

/** Parses a query string into raw strings, with no JSON handling. */
export function parseSearch(searchStr: string): SearchRecord {
  const normalized = searchStr.startsWith("?") ? searchStr.slice(1) : searchStr;
  const parsed: SearchRecord = {};
  for (const [key, value] of new URLSearchParams(normalized)) {
    parsed[key] = value;
  }
  return parsed;
}

/**
 * Deliberately *not* Next's encoding: Next went through `URLSearchParams`
 * (form-urlencoded, space -> `+`) where this emits `%20`. ANO-123 records the
 * divergence — no live call site emits an affected value, the goldens are built
 * on it, and `searchParamSerialization.spec.ts` pins `%20` never `+` on write,
 * both accepted on read.
 */
export function stringifySearch(search: SearchRecord): string {
  const pairs = Object.entries(search ?? {})
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return pairs.length > 0 ? `?${pairs.join("&")}` : "";
}
